'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import { SignUp } from '@clerk/nextjs'

export default function SignUpPage() {
  const searchParams = useSearchParams()

  useEffect(() => {
    document.title = 'Daftar Akun Baru | NoctrHost'
  }, [])

  const plan = searchParams.get('plan')
  const game = searchParams.get('game')
  const variant = searchParams.get('variant')

  // If ordering parameters exist, redirect to checkout, else go to dashboard overview
  const redirectUrl = plan && game && variant
    ? `/dashboard/checkout?plan=${plan}&game=${game}&variant=${variant}`
    : '/dashboard'

  return (
    <div>
      <h1 className="text-h3 font-display font-bold text-text-primary mb-2 text-center">
        Buat Akun Gratis
      </h1>
      <p className="text-body-sm text-text-muted text-center mb-6">
        Sudah punya akun?{' '}
        <a href="/sign-in" className="text-violet-400 hover:text-violet-300 underline">
          Masuk di sini
        </a>
      </p>

      {/* Clerk SignUp component */}
      <SignUp
        path="/sign-up"
        routing="path"
        signInUrl="/sign-in"
        afterSignUpUrl={redirectUrl}
        forceRedirectUrl={redirectUrl}
        appearance={{
          elements: {
            formButtonPrimary:
              'bg-violet-700 hover:bg-violet-600 text-white font-semibold rounded-md transition-colors',
            card: 'bg-transparent shadow-none p-0',
            headerTitle: 'hidden',
            headerSubtitle: 'hidden',
            socialButtonsBlockButton:
              'bg-bg-s2 border border-border text-text-primary hover:bg-bg-s3 rounded-md transition-colors',
            formFieldInput:
              'bg-bg-s3 border border-border text-text-primary rounded-md focus:border-violet-500 focus:ring-1 focus:ring-violet-500',
            formFieldLabel: 'text-body-sm text-text-primary font-medium',
            footerActionLink: 'text-violet-400 hover:text-violet-300',
          },
        }}
      />
    </div>
  )
}
